import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

const BASEURL = environment.apiBase;

@Injectable({
  providedIn: 'root'
})

export class PlaylistService {

  constructor(private http: HttpClient) { }

  public getResource(resourceId: number): Observable<any> {
    return this.http.get(`${BASEURL}/resources/${resourceId}.json`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        catchError(this.handleError<any>('login', []))
      );
  }

  public getUserResource(resourceId: number): Observable<any> {
    return this.http.get(`${BASEURL}/resources_playlist/${resourceId}.json`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        catchError(this.handleError<any>('login', []))
      );
  }

  public getPlaylist(playlistId: number): Observable<any> {
    return this.http.get(`${BASEURL}/playlists/${playlistId}.json`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        catchError(this.handleError<any>('getPlaylist', []))
      );
  }

  public getPlaylists(): Observable<any> {
    return this.http.get(`${BASEURL}/playlists.json`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        catchError(this.handleError<any>('getPlaylists', []))
      );
  }

  public getIntegrationPlaylists(): Observable<any> {
    return this.http.get(`${BASEURL}/playlists-integration.json`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        catchError(this.handleError<any>('login', []))
      );
  }


  public getComments(playlistId: number): Observable<any> {
    return this.http.get(`${BASEURL}/playlists/${playlistId}/comments.json`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        catchError(this.handleError<any>('login', []))
      );
  }

  public addComment(playlistId: number, text: string): Observable<any> {
    return this.http.post(`${BASEURL}/playlists/${playlistId}/comments.json`, {
      comment: {
        text
      }
    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        catchError(this.handleError<any>('login', []))
      );
  }

  public addResource(formData:FormData): Observable<any>{
    return this.http.post(`${BASEURL}/playlists`, formData, {
      headers:{'Authorization': localStorage.getItem('token')}
    })
  }

  public updateResource(resourceId: string,formData:FormData): Observable<any>{
    return this.http.put(`${BASEURL}/playlists/${resourceId}`, formData, {
      headers:{'Authorization': localStorage.getItem('token')}
    })
  }

  public destroyResource(resouceId: string): Observable<any>{
    return this.http.delete(`${BASEURL}/playlists/${resouceId}`, {
      headers:{'Authorization': localStorage.getItem('token')}
    })
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      console.error(error);
      return throwError(() => error);
    };
  }
}
